module.exports = __webpack_public_path__ + "static/media/no_skrivhastighet_video.70432b1d.mp4";